import { defineComponent as S, useCssModule as k, useSlots as B, ref as u, watch as P, onMounted as $, openBlock as q, createElementBlock as w, normalizeClass as M, unref as l, createElementVNode as N, renderSlot as C, createVNode as V, withCtx as x } from "vue";
import z from "../../utils/mapClasses.mjs";
import A from "../popup/CdrPopup.vue.mjs";
import H from "../../utils/propValidator.mjs";
import I from "../../utils/uid.mjs";
const F = /* @__PURE__ */ S({
  name: "CdrTooltip",
  __name: "CdrTooltip",
  props: {
    /**
     * Sets the position where the tooltip will render relative to the trigger element.
     * @demoSelectMultiple false
     * @values top, bottom, left, right
     */
    position: {
      type: String,
      required: !1,
      default: "top",
      validator: (t) => H(t, ["top", "bottom", "left", "right"])
    },
    /**
     * If set to `true`, tooltip will attempt to dynamically set it's position to
     * ensure it renders within the visible browser window.
     * If `false` the tooltip will always render in the provided `position`.
     */
    autoPosition: {
      type: Boolean,
      default: !0
    },
    /** ID for the tooltip element, required for accessibility */
    id: {
      type: String
    },
    /** Add custom class to the tooltip content wrapper. Allows for overriding size, styling, etc. */
    contentClass: {
      type: String,
      required: !1
    },
    /**
     * Used to programmatically control the tooltip state. Does not need to be set if you are using the `trigger` slot.
     * @demoIgnore true
     */
    open: {
      type: Boolean,
      default: !1
    }
  },
  emits: {
    /** Emits when tooltip is opened */
    opened: null,
    /** Emits when tooltip is closed */
    closed: null
  },
  setup(t, {
    emit: y
  }) {
    const s = t, c = y, m = s.id ? s.id : I(), h = k(), T = B(), r = u(!1);
    let a;
    const d = u(null), p = u(null), L = T.trigger, i = (e) => {
      a && clearTimeout(a), r.value = !0, c("opened", e);
    }, n = (e) => {
      a = setTimeout(() => {
        r.value = !1, c("closed", e);
      }, 250);
    }, b = () => {
      var o, f, v, g, E;
      const e = (o = p.value) == null ? void 0 : o.children[0];
      e && (e.addEventListener("mouseover", i), e.addEventListener("focus", i), e.addEventListener("mouseleave", n), e.addEventListener("blur", n), (v = (f = d.value) == null ? void 0 : f.$el) == null || v.addEventListener("mouseover", i), (E = (g = d.value) == null ? void 0 : g.$el) == null || E.addEventListener("mouseleave", n));
    };
    return P(() => s.open, () => s.open ? i() : n()), $(() => {
      var o;
      b();
      const e = (o = p.value) == null ? void 0 : o.children[0];
      e && e.setAttribute("aria-describedby", m);
    }), (e, o) => (q(), w("div", {
      class: M(l(z)(l(h), "cdr-tooltip--wrapper", l(L) ? "cdr-tooltip--position" : ""))
    }, [N("div", {
      ref_key: "triggerEl",
      ref: p
    }, [C(e.$slots, "trigger")], 512), V(A, {
      "content-class": t.contentClass,
      role: "tooltip",
      ref_key: "popupEl",
      ref: d,
      position: t.position,
      "auto-position": t.autoPosition,
      opened: r.value,
      id: l(m),
      onClosed: n
    }, {
      default: x(() => [C(e.$slots, "default")]),
      _: 3
    }, 8, ["content-class", "position", "auto-position", "opened", "id"])], 2));
  }
});
export {
  F as default
};
